module.exports = __webpack_public_path__ + "img/bg5.05b8bbcc.png";